export default __webpack_public_path__ + "static/media/camera.e1b3c50c.svg";